import { Typography } from "@mui/material";
import { styled, css } from "@mui/material/styles";
import { ExpandArrow } from "../../assets/icons/ExpandArrow.js";
import "react/jsx-runtime";
const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "8px 0",
  minHeight: "40px"
}));
const ExpandArrowIcon = styled(ExpandArrow, {
  shouldForwardProp: (props) => props !== "isExpanded"
})`
  ${({ isExpanded }) => isExpanded && css`
      transform: rotate(180deg);
    `}
`;
const Container = styled("div")`
  display: flex;
  flex-direction: column;

  ${({ open }) => open && css`
      height: calc(100% - 144px);
    `}
`;
const TodoListContainer = styled("div")`
  gap: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;
export {
  Container,
  ExpandArrowIcon,
  StyledTypography,
  TodoListContainer
};
